<recap [caseId]="caseId" (stageChanging)="gotoStage($event)" (recapFormOut)="receiveRecapForm($event)" doAddressMatch="true"></recap>
<form [formGroup]="dipOverviewForm" novalidate>
    <fieldset class="form-group">
        <div class="c-checkbox--list custom-controls-stacked c-block">
          <p class="mb-1">
            <sup>*</sup>
            I/we confirm that I/we have read, and agree to Together Commercial Finance Limited processing
            my/our personal information in accordance with the <a href="https://togethermoney.com/fair-processing-notice/" target="_blank">Together Commercial Finance Fair Processing Notice</a> along with
            the <a href="https://togethermoney.com/privacy-and-cookie-policy/" target="_blank">privacy policy</a>
            and <a href="https://togethermoney.com/website-terms-of-use/" target="_blank">terms of use</a> linked from this website
          </p>
            <span class="c-checkbox-button px-0">
                    <label class="custom-control custom-checkbox">
                        <input id="termsAgreed" name="checkbox-stacked" formControlName="termsAgreed" [checked]="termsAgreed.value === true" type="checkbox" class="custom-control-input">
                        <span class="custom-control-indicator"></span>
                                <span class="custom-control-description">
                            <strong>I/we confirm</strong>
                        </span>
                    </label>
            </span>
        </div>
    </fieldset>
</form>
<together-auction-dip-stage-select 
[forward_disabled]="dipOverviewForm.invalid" 
[forward_title]="'Submit for pre-approval'" 
[backward_title]="'Property details'" 
[show_action]="false" 
[show_forward]="true" 
[show_backward]="true" 
(on_forward)="onForwardClicked($event)" (on_backward)="onBackwardClicked($event)">
</together-auction-dip-stage-select>
<together-auction-dip-loading [is_loading]="isPageLoading"></together-auction-dip-loading>
